/*
 * Authors: mariushirjanu
 * Created: 10/03/2023
 */

import { HttpDataService, IHttpDataCache } from '../../../../shared/http/http-data.service';

import { IDescribedObject } from '../../../../../type_definitions/datatypes';
import { Injectable } from '@angular/core';

export interface IStockOrderType {
  id:number;
  value:string;
  sequence:number;
}

export interface IOrderType {
  id:number;
  type:string;
  description?:string;
  approvalNeeded?:boolean;
}

@Injectable()
export class OrderEntryInfoDataService {
  private cache:IHttpDataCache<any>;

  constructor(
    private httpDataService:HttpDataService
  ) {
    this.cache = this.httpDataService.createCache();
  }

  public orderTypes(webshopId:number):Promise<IOrderType[]> {
    return this.cache.doGET(
      `rest/orderentry/webshops/${webshopId}/ordertypes`,
      undefined,
      undefined,
      'Error loading order types'
    );
  }

  public costCenters(webshopId:number, countryId:number):Promise<IDescribedObject[]> {
    return this.cache.doGET(
      `rest/orderentry/webshops/${webshopId}/countries/${countryId}/costcenters`,
      undefined,
      undefined,
      'Error loading cost centers'
    );
  }

  public stockOrderTypes(webshopId:number, countryId:number, companyCountryId:number):Promise<IStockOrderType[]> {
    return this.cache.doGET(
      `rest/orderentry/webshops/${webshopId}/countries/${countryId}/stockordertypes?companyCountryId=${companyCountryId}`,
      undefined,
      undefined,
      'Error loading stock order types'
    );
  }

  public clear():void {
    this.cache.clear();
  }
}